// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_RAw","cls2":"LoswpTabsHero-cls2_6Ka LoswpTabsHero-cls1_RAw"};